import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '../../../assets/map/ja/pickey.png';
import _imports_1 from '../../../assets/map/ja/ewm.png';
const _hoisted_1 = {
  class: "mapcontainer jas"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "logo"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  id: "map",
  class: "map_content",
  ref: "maps"
};
const _hoisted_6 = {
  class: "pointTitle"
};
const _hoisted_7 = {
  class: "pointList"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "swiper-wrapper"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "fun1box"
};
const _hoisted_14 = {
  class: "txtbox"
};
const _hoisted_15 = {
  class: "title"
};
const _hoisted_16 = {
  key: 0,
  class: "address14"
};
const _hoisted_17 = {
  key: 1,
  class: "address14 address"
};
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
  class: "funbox"
};
const _hoisted_20 = {
  key: 0,
  class: "li1"
};
const _hoisted_21 = {
  key: 1,
  class: "li2"
};
const _hoisted_22 = {
  key: 2,
  class: "li3"
};
const _hoisted_23 = {
  key: 3,
  class: "li4"
};
const _hoisted_24 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_circle_close_filled = _resolveComponent("circle-close-filled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_BellFilled = _resolveComponent("BellFilled");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_CaretRight = _resolveComponent("CaretRight");
  const _component_PictureFilled = _resolveComponent("PictureFilled");
  const _component_position = _resolveComponent("position");
  const _component_promotion = _resolveComponent("promotion");
  const _component_list = _resolveComponent("list");
  const _component_home_filled = _resolveComponent("home-filled");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "mapbg",
    src: $options.handleHttp($data.mapconfigData.mapbg),
    alt: ""
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    class: "logoimg",
    src: $options.handleHttp($data.mapconfigdatas.logo),
    alt: ""
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, null, 512), $data.typeList && $data.typeList.length > 0 && $data.mapTitle == '吉安市地图' ? (_openBlock(), _createElementBlock("ul", {
    key: 0,
    class: _normalizeClass(["navul", 'style' + $data.modeltype])
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass({
        'on': $data.currentType === index
      }),
      key: index,
      style: _normalizeStyle($data.currentType === index ? $data.listobjon : $data.listyleobj)
    }, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pointList, point => {
      return _openBlock(), _createElementBlock("div", {
        class: "point",
        onClick: $event => $options.typeselect(point, index)
      }, "· " + _toDisplayString(point.name), 9, _hoisted_8);
    }), 256))])], 6);
  }), 128))], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(["pickey", [`fid${$data.fid}`]])
  }, [...(_cache[7] || (_cache[7] = [_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1)]))], 2), _withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["popcontainer", 'style' + $data.modeltype])
  }, [_createVNode(_component_el_icon, {
    class: "icon_close",
    onClick: $options.closepopshow,
    style: _normalizeStyle({
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_circle_close_filled)]),
    _: 1
  }, 8, ["onClick", "style"]), _createElementVNode("div", {
    class: "imgcontent",
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1,
      '--textbg': $data.mapconfigdatas.textbg
    })
  }, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      'on': $data.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.handleHttp(item.fileUrl)
    }, null, 8, _hoisted_10)]);
  }), 128))]), _createElementVNode("div", {
    class: "swiper-pagination",
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1,
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    }),
    ref: "swiperpage"
  }, null, 4)], 2), _createElementVNode("video", {
    class: _normalizeClass(["visibleitem", {
      'on': $data.detail.currentShowtype === 'video'
    }]),
    src: $data.detail.videourl,
    controls: "",
    autoplay: ""
  }, null, 10, _hoisted_11), _createElementVNode("audio", {
    class: _normalizeClass(["visibleitem", {
      'on': $data.detail.currentShowtype === 'audio'
    }]),
    src: $data.detail.audiourl,
    controls: "",
    autoplay: ""
  }, null, 10, _hoisted_12)], 4), _createElementVNode("ul", _hoisted_13, [$data.detail.audio !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1
    }),
    class: "li2",
    onClick: _cache[0] || (_cache[0] = $event => $options.showType('audio'))
  }, [_createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "音频",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_BellFilled)]),
      _: 1
    })]),
    _: 1
  })], 4)) : _createCommentVNode("", true), $data.detail.video !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 1,
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1
    }),
    class: "li3",
    onClick: _cache[1] || (_cache[1] = $event => $options.showType('video'))
  }, [_createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "视频",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_CaretRight)]),
      _: 1
    })]),
    _: 1
  })], 4)) : _createCommentVNode("", true), $data.detail.banner !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 2,
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1
    }),
    class: "li1",
    onClick: _cache[2] || (_cache[2] = $event => $options.showType('banner'))
  }, [_createVNode(_component_el_tooltip, {
    class: "box-item",
    effect: "dark",
    content: "图片",
    placement: "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_PictureFilled)]),
      _: 1
    })]),
    _: 1
  })], 4)) : _createCommentVNode("", true)]), _createElementVNode("div", {
    class: "textcontainer",
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1,
      '--textbg': $data.mapconfigdatas.textbg
    })
  }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("h2", _hoisted_15, _toDisplayString($data.detail.placeName), 1), parseInt($data.modeltype) == 2 && $data.detail.address14 !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString($data.detail.address14), 1)) : _createCommentVNode("", true), $data.detail.address ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString($data.detail.address), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "infodesc",
    innerHTML: $data.detail.introduce,
    style: _normalizeStyle({
      '--colortheme1': $data.mapconfigdatas.colorTheme1
    })
  }, null, 12, _hoisted_18)]), _createElementVNode("ul", _hoisted_19, [$data.detail.route !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_20, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.goLink($data.detail, 0)),
    style: _normalizeStyle({
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    }),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_position)]),
    _: 1
  }), _cache[8] || (_cache[8] = _createTextVNode("路线", -1))], 4)])) : _createCommentVNode("", true), $data.detail.virtualLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_21, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => $options.goLink($data.detail.virtualLink, 1)),
    style: _normalizeStyle({
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    }),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_promotion)]),
    _: 1
  }), _cache[9] || (_cache[9] = _createTextVNode("虚拟展馆", -1))], 4)])) : _createCommentVNode("", true), $data.detail.specialLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_22, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLink($data.detail.specialLink, 1)),
    style: _normalizeStyle({
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    }),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_list)]),
    _: 1
  }), _cache[10] || (_cache[10] = _createTextVNode("专题", -1))], 4)])) : _createCommentVNode("", true), $data.detail.portalLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_23, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => $options.goLink($data.detail.portalLink, 1)),
    style: _normalizeStyle({
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    }),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_home_filled)]),
    _: 1
  }), _cache[11] || (_cache[11] = _createTextVNode("门户", -1))], 4)])) : _createCommentVNode("", true)])], 4)], 2), [[_vShow, $data.popshowflag]]), _cache[13] || (_cache[13] = _createElementVNode("div", {
    class: "ewmbox"
  }, [_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })], -1)), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_24), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    style: _normalizeStyle({
      '--colortheme2': $data.mapconfigdatas.colorTheme2
    }),
    round: ""
  }, {
    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("返回", -1)]))]),
    _: 1
  }, 8, ["onClick", "style"]), [[_vShow, $data.linkcontainerflag]])]);
}